import { forwardRef } from "react";
import { Menu as MuiMenu } from "@mui/material";

import type { MenuProps as MuiMenuProps } from "@mui/material";

/** Elevation of the popover surface, per the Centro Menu spec. */
const SURFACE_ELEVATION = 8;

export interface MenuProps extends Omit<
  MuiMenuProps,
  // Locked: the surface is the Centro elevation-8 popover, bound to the theme.
  "PaperProps" | "slotProps" | "MenuListProps"
> {
  /** Root test id. Default: `"ds-menu"` */
  "data-testid"?: string;
}

/**
 * Centro dropdown / context-menu surface over MUI Menu. Anchor with `anchorEl`
 * for a dropdown or `anchorReference="anchorPosition"` + `anchorPosition` for a
 * right-click context menu — the styling is identical either way.
 */
export const Menu = forwardRef<HTMLDivElement, MenuProps>(
  ({ "data-testid": dataTestId = "ds-menu", children, ...rest }, ref) => (
    <MuiMenu
      {...rest}
      ref={ref}
      data-testid={dataTestId}
      slotProps={{ paper: { elevation: SURFACE_ELEVATION } }}
    >
      {children}
    </MuiMenu>
  ),
);

Menu.displayName = "Menu";
